import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const RolesPage = lazy(() =>
  import('./pages/RolesPage').then((module) => ({ default: module.RolesPage })),
);
const PermissionsPage = lazy(() =>
  import('./pages/PermissionsPage').then((module) => ({ default: module.PermissionsPage })),
);
const RoleDetailPage = lazy(() =>
  import('./pages/RoleDetailPage').then((module) => ({ default: module.RoleDetailPage })),
);

/**
 * RBAC management, Gerencia-only. Guarded by `iam.view_role` at the layout
 * level; the create/assign buttons inside are additionally gated by
 * `iam.manage_role` / `iam.assign_role`.
 */
export const iamRoutes: RouteObject[] = [
  {
    path: 'roles',
    element: createElement(ProtectedRoute, { view: 'roles' }),
    children: [
      { index: true, element: createElement(RolesPage) },
      { path: ':id', element: createElement(RoleDetailPage) },
    ],
  },
  {
    path: 'permissions',
    element: createElement(ProtectedRoute, { view: 'permissions' }),
    children: [{ index: true, element: createElement(PermissionsPage) }],
  },
];
